import React from "react";

const Keyword = ({ children, color = "#17A257" }) => (
  <code
    className="px-2 py-0.5 rounded-md bg-[#F4F8F7] font-semibold text-[13px] tracking-tight font-mono inline-block"
    style={{ color }}
  >
    {children}
  </code>
);

export default Keyword;
